export enum EditingSection {
  WELCOME_SCREEN = 'welcomeScreen',
  BODY_CONTENT = 'bodyContent',
  EXIT_SCREEN = 'exitScreen',
  HEADER = 'header',
  FOOTER = 'footer',
  PAGE_TEMPLATE = 'pageTemplate',
}

export const SECTION_LABELS: Record<EditingSection, string> = {
  [EditingSection.WELCOME_SCREEN]: 'Welcome Screen',
  [EditingSection.HEADER]: 'Header Section',
  [EditingSection.PAGE_TEMPLATE]: 'Page Section',
  [EditingSection.BODY_CONTENT]: 'Body Section',
  [EditingSection.FOOTER]: 'Footer Section',
  [EditingSection.EXIT_SCREEN]: 'Exit Screen',
};
